var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product-map',{attrs:{"num":9,"respons":_vm.res}})
}
var staticRenderFns = []

export { render, staticRenderFns }